// eslint-disable-next-line import/prefer-default-export
import store from "@/store/index"

export const authMutations = {
    AUTHENTICATED(state, authData) {
        state.loginError = false
        state.authenticated = true
        state.accessToken = authData.access_token
        state.idToken = `${authData.token_type} ${authData.access_token}`
        state.expiresAt = authData.expires_in * 1000 + new Date().getTime()
        state.role = authData.role
        state.name = authData.name
        state.picture = authData.picture
        
        localStorage.setItem('access_token', state.accessToken)
        localStorage.setItem('id_token', state.idToken)
        localStorage.setItem('expiresAt', state.expiresAt)
    },

    LOGOUT(state) {
        state.authenticated = false
        state.accessToken = null
        state.idToken = false
        state.expiresAt = null
        state.role = null
        state.name = null
        state.picture = null

        store.commit('REMOVE_INSTALLATIONS');

        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expiresAt')
        localStorage.removeItem('CLEAR_PARC_DATES')
        localStorage.clear()

        location.assign('/login')
    },

    SET_LOGIN_ERROR(state, error) {
        state.loginError = error
    }

}
